export default {
  toasts: {
    failed_to_delete_website: 'Website verwijderen mislukt',
    website_deleted: 'Website verwijderd',
  },
  delete_model: {
    title: 'Weet u zeker dat u de website wilt verwijderen?',
    confirm: 'Verwijderen',
    cancel: 'Annuleren',
  },
  buttons: {
    open_editor: 'Editor openen',
    transfer_website: 'Website overdragen',
    delete_site: 'Verwijderen',
  },
};
